/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, useEffect, useState } from "react";
import { useAuth } from "src/hooks/auth";
import { api } from "src/services/api";
import { Container, Content } from "./styles";
import "./style.css";
import {
	ModalClose,
	ModalContainer,
	ModalContent,
	ModalRoot,
} from "src/components/ui/modal";
import { Trash2 } from "lucide-react";
import { OTPInput } from "src/components/OTPInput";
import { OTPInputPassword } from "src/components/OTPInputPassword";
import { isAxiosError } from "src/utils/isAxiosError";
import { showAlertError } from "src/components/alertError";
import { showAlertSuccess } from "src/components/alertSuccess";
import { ModalLoader } from "src/components/modalLoader";
import { setAuthToken } from "src/utils/setAuthToken";
import successNewPixTransaction from "src/assets/successNewPixTransaction.svg";
import transactionSpinner from "src/assets/transactionSpinner.svg";

type TransactionData = {
	os: string;
	browser: string;
	status: boolean;
};

interface ContactProps {
	id: string;
	contactName: string;
	keyPix: string;
	keyType: string;
}

// const fakeData: TransactionData[] = [
// 	{ id: "1", description: "Máquina A", serialNum: "12345", status: "Ativo" },
// 	{ id: "2", description: "Máquina B", serialNum: "67890", status: "Inativo" },
// 	{ id: "3", description: "Máquina C", serialNum: "54321", status: "Ativo" },
// 	{ id: "4", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "5", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "6", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "7", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "8", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "9", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// 	{ id: "10", description: "Máquina D", serialNum: "98765", status: "Ativo" },
// ];

export function EnableDevices() {
	const token = localStorage.getItem("@stricv2:token");
	const [data, setData] = useState<TransactionData[]>([]);
	const { account, user } = useAuth();
	const [contacts, setContacts] = useState<ContactProps[]>([]);
	const [isOpen, setIsOpen] = useState(false);
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [clickedValues, setClickedValues] = useState<string[]>([]);
	const [otp, setOtp] = useState<string[]>([]);
	const [step, setStep] = useState(1);

	const fetchDevices = async () => {
		try {
			const { data: responseData } = await api.get(`/current-device`, {
				headers: { Authorization: `Bearer ${token}` },
			});
			const deviceArray = Array.isArray(responseData)
				? responseData
				: [responseData];
			setData(deviceArray);

			console.log("Dados recebidos:", deviceArray);
		} catch (error) {
			console.error("Erro ao buscar os dados:", error);
		}
	};

	useEffect(() => {
		fetchDevices();
	}, []);

	const fetchContacts = async () => {
		try {
			let url = `/pix/favorites`;
			const { data } = await api.get<ContactProps[]>(url, {
				headers: { Authorization: "Bearer " + token },
			});

			setContacts(data);
		} catch (error) {
			console.error("Error fetching contacts:", error);
		}
	};

	const handleDeleteContact = async (id: string) => {
		try {
			let url = `/pix/favorites`;
			await api.delete(`${url}/${id}`, {
				headers: { Authorization: "Bearer " + token },
			});

			fetchContacts();
		} catch (error) {
			console.error("Error deleting contact:", error);
		}
	};

	const handleOpenModal = async () => {
		setIsOpen(true);
		setIsSubmitting(true);
		try {
			setAuthToken();
			await api.post("/send-email-token", {
				email: user.email,
			});
			showAlertSuccess("Email enviado com sucesso!");
		} catch (error) {
			if (isAxiosError(error) && error.response) {
				const errorMessage = (error.response.data as { message: string })
					.message;
				showAlertError(errorMessage);
			} else {
				showAlertError("Ocorreu um erro inesperado.");
			}
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleResendEmail = async () => {
		try {
			setAuthToken();
			await api.post("/send-email-token", {
				email: user.email,
			});
			showAlertSuccess("Email enviado com sucesso!");
		} catch (error) {
			if (isAxiosError(error) && error.response) {
				const errorMessage = (error.response.data as { message: string })
					.message;
				showAlertError(errorMessage);
			} else {
				showAlertError("Ocorreu um erro inesperado.");
			}
		}
	};

	const handleOTPChange = (e: ChangeEvent<HTMLInputElement>, index: number) => {
		setClickedValues((prevValues) => {
			const updatedValues = [...prevValues];
			updatedValues[index] = e.target.value;
			return updatedValues;
		});
	};

	const handleOTPPinChange = (
		e: ChangeEvent<HTMLInputElement>,
		index: number,
	) => {
		setOtp((prevValues) => {
			const updatedValues = [...prevValues];
			updatedValues[index] = e.target.value;
			return updatedValues;
		});
	};

	const onComplete = async (pin: string) => {
		setIsSubmitting(true);
		try {
			setAuthToken();
			await api.post("/validate-email-token", {
				token: pin,
			});
			setStep(2);
		} catch (error) {
			if (isAxiosError(error) && error.response) {
				const errorMessage = (error.response.data as { message: string })
					.message;
				showAlertError(errorMessage);
			} else {
				showAlertError("Ocorreu um erro inesperado.");
			}
		} finally {
			setIsSubmitting(false);
		}
	};

	const onCompletePin = async (pin: string) => {
		setIsSubmitting(true);
		try {
			setAuthToken();
			await api.post("/device", {
				pin,
			});
			setStep(4);
			fetchDevices();
		} catch (error) {
			if (isAxiosError(error) && error.response) {
				const errorMessage = (error.response.data as { message: string })
					.message;
				if (errorMessage === "Limite de dispositivos atingido") {
					return setStep(3);
				}
				showAlertError(errorMessage);
			} else {
				showAlertError("Ocorreu um erro inesperado.");
			}
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<Container className="w-full">
			<Content className="w-full h-full padding-container items-center justify-center">
				<div className="flex flex-col items-center justify-center w-full px-[2%]">
					<span className="title-text">DISPOSITIVO ATUAL</span>

					<div className="w-full">
						<div className="flex flex-col rounded-lg bg-white w-full height-table">
							<table className="w-full border-collapse border-none">
								<thead className="bg-gray-100">
									<tr className="text-center font-semibold">
										<th className="table-title text-center align-middle  text-gray-700 bg-gray-100">
											Nome do Navegador
										</th>
										<th className="table-title text-center align-middle  text-gray-700 bg-gray-100">
											Sistema Operacional
										</th>
										<th className="table-title text-center align-middle  text-gray-700 bg-gray-100">
											Ação
										</th>
									</tr>
								</thead>
							</table>
							<div className="overflow-y-auto h-full">
								<table className="w-full border-collapse border-none">
									<tbody>
										{data.map((machine) => (
											<tr
												key={machine.browser}
												className="text-center font-medium h-20 border-b border-gray-200 hover:bg-gray-100"
											>
												<td className="table-text text-center align-middle  text-gray-600">
													{machine.browser}
												</td>
												<td className="table-text text-center align-middle  text-gray-600">
													{machine.os}
												</td>
												<td className="table-text text-center align-middle  text-gray-600">
													<button
														className={`text-white  rounded-md px-4 py-2 ${machine.status ? "bg-green-500" : "bg-red-500"}`}
														type="button"
														disabled={machine.status}
														onClick={handleOpenModal}
													>
														{machine.status
															? "Dispositivo cadastrado"
															: "Cadastrar dispositivo"}
													</button>
												</td>
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</Content>
			<ModalRoot open={isOpen} setIsOpen={setIsOpen}>
				<ModalContainer>
					<ModalContent>
						<ModalClose />
						{isSubmitting ? (
							<div className="flex flex-col gap-[1.875rem] items-center justify-center px-12 py-20 drop-shadow-md rounded-[1.875rem]">
								<p className="text-[1.875rem] w-64 text-center font-semibold">
									Aguarde, estamos processando a sua solicitação!
								</p>
								<img
									src={transactionSpinner}
									alt="spinner"
									className="animate-spin transition"
								/>
							</div>
						) : (
							<>
								{step === 1 ? (
									<div className="flex flex-col gap-4 items-center p-4">
										<h3 className="text-[1.875rem] font-semibold text-center">
											Enviamos um token para seu email <br /> digite o Token
											abaixo
										</h3>
										<OTPInputPassword
											length={6}
											formData={clickedValues}
											handleChange={handleOTPChange}
											onComplete={onComplete}
										/>
										<button
											onClick={handleResendEmail}
											type="button"
											className="text-purple-500 underline"
										>
											reenviar codigo
										</button>
									</div>
								) : step === 2 ? (
									<div className="flex flex-col gap-4 items-center p-4">
										<h3 className="text-[1.875rem] font-semibold text-center">
											Digite seu pin de segurança
										</h3>
										<OTPInputPassword
											length={4}
											formData={otp}
											handleChange={handleOTPPinChange}
											onComplete={onCompletePin}
										/>
									</div>
								) : step === 3 ? (
									<div className="flex flex-col gap-4 items-center p-4">
										<h1 className="text-[1.875rem] font-bold">
											Já existem 3 dispositivos cadastrados
										</h1>
										<div className="w-full flex gap-3 justify-center">
											<button
												type="button"
												onClick={() => setStep(1)}
												className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
											>
												Voltar
											</button>
										</div>
									</div>
								) : (
									<div className="flex flex-col gap-4 items-center p-4">
										<img src={successNewPixTransaction} alt="check icon" />
										<p className="text-[1.875rem] font-semibold text-center w-80">
											Dispositivo cadastrado com sucesso!
										</p>
									</div>
								)}
							</>
						)}
					</ModalContent>
				</ModalContainer>
			</ModalRoot>
		</Container>
	);
}
